import { render, staticRenderFns } from "./course_knowledge.vue?vue&type=template&id=2ef6d92c&scoped=true&"
import script from "./course_knowledge.vue?vue&type=script&lang=js&"
export * from "./course_knowledge.vue?vue&type=script&lang=js&"
import style0 from "./course_knowledge.vue?vue&type=style&index=0&id=2ef6d92c&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef6d92c",
  null
  
)

export default component.exports